import type { Editor } from "@tiptap/core";
import { cn } from "cn";
import { FormatToolBar } from "./format-tool-bar";

export const InlineMenu = ({
  openInlineMenu,
  editor,
  className,
}: {
  openInlineMenu: boolean;
  editor: Editor;
  className?: string;
}) => {
  return (
    <FormatToolBar
      editor={editor}
      className={cn(
        /* sorted */
        "p-2 pb-0",
        !openInlineMenu && "hidden",
        className,
      )}
    />
  );
};
